import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';
import { toast } from 'sonner';

const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};
export const getSubmissionsForAttestation = async (id) => {
    try {
        const url = `${BASE_URL}/organisation/attestationRequest?organisationId=${id}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

// /organisation/attestaionRequest?submissionId=<id></id>

export const sendSubmissionForAttestation = async (subId) => {
    try {
        const url = `${BASE_URL}/organisation/attestationRequest?submissionId=${subId}`;

        const accessToken = await getAccessToken();
        const response = await axios.post(url, {}, getConfig(accessToken));

        if (response.status === 201) toast.success('Sent For Attestation !');
        return response.status;
    } catch (error) {
        toast.error(error);
        // toast.error('Sorry unable to create your organization.');
    }
};
